/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

const key = 'userRoles';

export const initialState = {
  roleName: '',
  clientRoleId: null as number | null,
  defaultView: null as number | null,
  rights: [] as Array<{ rightId: number; rightName: string }>,
  canAssignLoanOfficer: true,
  viewDeliveryAndCommitment: true,
  isLoading: false,
  error: '',
};

const slice = createSlice({
  name: key,
  initialState,
  reducers: {
    setUserClientRolesLoading: (state) => {
      state.isLoading = true;
      state.error = '';
    },
    setUserClientRolesSuccess: (state, { payload }) => {
      state.roleName = payload.roleName;
      state.clientRoleId = payload.clientRoleId;
      state.defaultView = payload.defaultView;
      state.rights = payload.rights;
      state.canAssignLoanOfficer = payload.canAssignLoanOfficer;
      state.viewDeliveryAndCommitment = payload.viewDeliveryAndCommitment;
      state.isLoading = false;
      state.error = '';
    },
    setUserClientRolesError: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export const userRolesActions = {
  ...slice.actions,
  fetchUserClientRoles: createAction(`${key}/fetchUserClientRoles`),
};

export default slice.reducer;
